/**
 * מזהה פסאודונימי לכלי האנליטיקה (HAT-1081): במקום לשלוח את המייל של המשתמש
 * ל-PostHog / GA / Application Insights, שולחים SHA-256 של המייל + salt פר-סביבה.
 * ה-salt זהה בין שני הלקוחות (viewer-client ו-new-viewer-client) כדי שהמשתמש
 * יקבל אותו מזהה בכל הכלים ובשני ה-UI. ה-salt נמצא ב-bundle ולכן הוא הקשחה
 * נגד היפוך ההאש, לא סוד.
 */

const cache = new Map<string, string>();

export const getPseudonymousId = async (email: string): Promise<string | null> => {
  const normalized = email.trim().toLowerCase();
  if (!normalized) return null;

  const cached = cache.get(normalized);
  if (cached) return cached;

  // crypto.subtle קיים רק ב-secure context; בלעדיו עדיף לוותר על זיהוי מאשר לחשוף מייל
  if (!window.crypto?.subtle) return null;

  const salt = import.meta.env.VITE_ANALYTICS_ID_SALT ?? '';
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(normalized + salt));
  const hex = Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');

  const pseudonymousId = `u_${hex}`;
  cache.set(normalized, pseudonymousId);
  return pseudonymousId;
};
